// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/certifications-report/certifications-report.less
// module id = 3935
// module chunks = 0